(function() { window.GUID_90b5f1a3_754b_4cf0_b11e_73173b4e22ea = { getGuid: function() { return "90b5f1a3-754b-4cf0-b11e-73173b4e22ea"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_select_fees extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "make-payment";
            }
            OnLoad() {
                let me = this;
                this.$StepDiv.offon('click.' + this.Wizard.UniqueNamespace, '.button.more-encounters', function () {
                    let divId = $(this).data('divid');
                    let divisionId = $(this).data('divisionid');
                    me.ShowMoreEncounterFees(divId, divisionId, 1);
                });
            }
            ShowMoreEncounterFees(divId, divisionId, skip) {
                let data = $('#' + this.Wizard.ControlId + '-form-' + this.Wizard.CurrentStep).serializeArray();
                data.push({ name: "StepName", value: 'select-fees' });
                data.push({ name: "divisionId", value: divisionId });
                data.push({ name: "skip", value: skip });
                let newUrl = CS.Url.Action('ShowMoreEncounterFees', 'SportEventFees');
                CS.Ajax.Post(newUrl, data, function (response) {
                    if (response.success) {
                        let currentDiv = $('#div-all-encounters-' + divId);
                        currentDiv.html(response.view);
                    }
                });
            }
            OnCheckIfCanContinue() {
                let checked = this.$StepDiv.find("input:checked");
                return checked.length !== 0;
            }
            OnSubmit() {
                let rf = this.$StepDiv.find("input[name^='rf_']:checked").map((i, e) => { return e.name.split('_')[1] + '_' + e.name.split('_')[2]; });
                let $RegistrationFees = this.$StepDiv.find("#Payment_RegistrationFees");
                $RegistrationFees.empty();
                rf.each((i, v) => {
                    $('<input type="hidden" />').attr({ name: 'SelectedRegistrationFees[' + i + ']' }).val(v).appendTo($RegistrationFees);
                });
                let sf = this.$StepDiv.find("input[name^='sf_']:checked").map((i, e) => { return e.name.split('_')[1] + '_' + e.name.split('_')[2]; });
                let $SanctionFees = this.$StepDiv.find("#Payment_SanctionFees");
                $SanctionFees.empty();
                sf.each((i, v) => {
                    $('<input type="hidden" />').attr({ name: 'SelectedSanctionFees[' + i + ']' }).val(v).appendTo($SanctionFees);
                });
                let ef = this.$StepDiv.find("input[name^='ef_']:checked").map((i, e) => { return e.name.split('_')[1] + '_' + e.name.split('_')[2] + '_' + e.name.split('_')[3] + '_' + e.name.split('_')[4]; });
                let $EncounterFees = this.$StepDiv.find("#Payment_EncounterFees");
                $EncounterFees.empty();
                ef.each((i, v) => {
                    $('<input type="hidden" />').attr({ name: 'SelectedEncounterFees[' + i + ']' }).val(v).appendTo($EncounterFees);
                });
            }
        }
        Controls.popupwizard_sportevent_fees_select_fees = popupwizard_sportevent_fees_select_fees;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=select-fees.js.map
